<template>
  <div>
    <form novalidate @change="eventActivateUpdateFlag('ResourcesCapacity')">
        <div class="row mt-5">
        <div class="col-sm-12 d-flex align-items-center mb-3">
            <label class="full">
            Total Capacity
            <input type="text" class="bg-lighter mt-1" size="2" v-model="getSelectedEvent.maximumLotation">
            </label>
            <checkbox name="allotment" class="ml-3 mt-3" v-model="hasAllotments">Set Allotment</checkbox>
        </div>
        </div>

        <div class="row pt-4 border-top-light" v-if="hasAllotments">
            <div class="w-100 d-flex mb-3 align-items-center" v-for="allotment, index in this.getSelectedEvent.eventAlotments">
                <div class="col-sm-2">
                    <label class="full">
                        Allotment
                        <input type="number" class="bg-lighter" size="10" v-model="allotment.quantityAlotment">
                    </label>
                </div>
                <div class="col-sm-4">
                    <label class="full">
                        Linked To
                    </label>
                    <v-select :options="allotedToOptions"  v-model="allotment.linkedTo" @input="allotmentLinkedToChanged(allotment)"></v-select>
                </div>
                <div class="col-sm-4" v-if="allotment.linkedTo.value == 'agent'">
                    <label class="full">
                        Name
                    </label>
                    <v-select :options="availableAgents" label="name" v-model="allotment.agent" @input="allotmentNameChanged(allotment.agent, availableAgents, allotment)"></v-select>
                </div>
                <i class="ico ico-delete largest dark pointer mt-3" @click="removeAllotment(index)"></i>
            </div>
            <div class="col-sm-12 mt-3 mb-4">
                <span @click="addAllotment">
                    <span class="ico-add color-1 mr-1 rounded-circle border-color-1 p-1 pointer"></span>
                    <label class="pointer">Add New</label>
                </span>
            </div>
        </div>
    </form>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        created: function(){
            for (let allotment of this.getSelectedEvent.eventAlotments) {

                if(allotment.agent !== null){
                    allotment.linkedTo = {
                        label:'Agent',
                        value:'agent'
                    }
                } else {
                    allotment.linkedTo = {
                        label:'My Team',
                        value:'myTeam'
                    }
                }
            }

        },
        mixins: [ ],
        props: {
            validations: {
                type: Object
            }
        },
        data: function() {
            return {
                setAllotment: false,
                allotedToOptions:[
                    {
                        label:'Agent',
                        value:'agent'
                    },
                    {
                        label:'My Team',
                        value:'myTeam'
                    }
                ]
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent',
                'getAgents',
                'account'
            ]),
            availableAgents: function(){
                return this.getAgents
            },
            hasAllotments: {
                get: function() {
                    return this.getSelectedEvent.eventAlotments.length > 0
                },
                set: function() {
                    if(this.hasAllotments){
                        this.getSelectedEvent.eventAlotments = [];
                    } else {
                        this.addAllotment()
                    }
                }
            }
        },
        methods:{
            addAllotment: function(){
                this.eventActivateUpdateFlag('ResourcesCapacity')

                this.getSelectedEvent.eventAlotments.push({
                    agent: null,
                    supplier: null,
                    linkedTo: {
                        label:'My Team',
                        value:'myTeam'
                    },
                    supplierMember: null,
                    quantityAlotment: 0,
                });

            },
            removeAllotment: function(index){
                this.eventActivateUpdateFlag('ResourcesCapacity')
                this.getSelectedEvent.eventAlotments.splice(index, 1);
            },
            allotmentLinkedToChanged: function(allotment) {
                this.eventActivateUpdateFlag('ResourcesCapacity')
                console.log('allotmentLinkedToChanged triggered');
                if(allotment.supplier !== null){
                    console.log('this is for My team');

                    allotment.agent = null;
                    allotment.supplier = this.account;
                    allotment.supplierMember = this.account;
                } else {
                    console.log('this is for an Agent');

                    allotment.supplier = null;
                    allotment.supplierMember = null;
                }

                this.$forceUpdate();

            },
            allotmentNameChanged: function(agent, b, allotment){
                this.eventActivateUpdateFlag('ResourcesCapacity')
                allotment.agent = agent;
                allotment.supplier = null;
                allotment.supplierMember = null;

                console.log(allotment);
                console.log(b);
            },
            setAllotmentChanged: function(e){
                console.log('setAllotmentChanged: ');
            }
        },
        components: {
          vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// areaCapacity.vue?15f81d60